import { DSPostShortWithAuthor, LinkedLinkProps } from 'shared-definitions/types'
import { ApiPostShortPropsWithAuthor } from 'data-source/types.wp'
import { onePostMapper } from 'data-source/mappers/onePostMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { imageMapper } from './imageMapper'

export interface OnePostWithAuthorMapperOpts extends PLinkMapperOpts {
  authorLinkBuilder: (slug: string) => LinkedLinkProps
}

export function onePostWithAuthorMapper(
  input: ApiPostShortPropsWithAuthor,
  opts: OnePostWithAuthorMapperOpts
): DSPostShortWithAuthor {
  return {
    ...onePostMapper(input, opts),
    author:
      input.author_name && input.author_slug
        ? {
            name: input.author_name,
            image: imageMapper(input.author_avatar, opts),
            pLink: opts.authorLinkBuilder(input.author_slug),
          }
        : null,
  }
}
